import { application } from "./application"

const controllers = import.meta.glob("./*_controller.js", { eager: true })

for (const path in controllers) {
  const identifier = path
    .replace(/^\.\//, "")
    .replace(/_controller\.js$/, "")
    .replace(/_/g, "-")

  application.register(identifier, controllers[path].default)
}
